import React from "react";
import DocumentTitle from "react-document-title";
import { enquireScreen } from "enquire-js";
import Banner from "./Banner";
import "./static/style";
import Header from "../Page/components/Header";

let isMobile = false;
enquireScreen((b) => {
  isMobile = b;
});

class Home extends React.PureComponent {
  state = {
    isMobile,
    showShadow: false,
    isBgWhite: false,
    activeHome: false,
    activeProduct: false,
    activefaq: false,
    isScroll: false,
  };

  componentDidMount() {
    enquireScreen((b) => {
      this.setState({
        isMobile: !!b,
      });
    });
    // window.addEventListener("scroll", this.bindScroll);
  }


  bindScroll = (event) => {
    this.setState({
      isScroll: true,
    });
    const scrollTop =
      (event.srcElement ? event.srcElement.documentElement.scrollTop : false) ||
      window.pageYOffset ||
      (event.srcElement ? event.srcElement.body.scrollTop : 0);

    console.log(scrollTop,'scrollTopscrollTop');
    if (scrollTop > 0) {
      this.setState({
        isBgWhite: true,
      });
    } else {
      this.setState({
        isBgWhite: false,
      });
    }

    // const homeOT = document.getElementById('home').offsetTop - 64;
    // const producteOT =
    //   document.getElementById("product").offsetTop - window.innerHeight / 2;
    // const faqOT =
    //   document.getElementById("FAQ").offsetTop - window.innerHeight / 2;
    // if (scrollTop < producteOT) {
    //   this.setState({
    //     activeHome: false,
    //     activeProduct: false,
    //     activefaq: false,
    //   });
    // } 
  };
  navToShadow = (e) => {
    this.setState({ showShadow: e.mode === "leave" });
  };
  jumpToSection = (id) => {
    let element = document.getElementById(id);
    if (element) {
      // 64 header高度
      window.scrollTo(0, element.offsetTop - 64);
    }
  };


  render() {
    const renderInfo = () => {
      return [
        <Banner
          key="banner"
          isMobile={this.state.isMobile}
          navToShadow={this.navToShadow}
        />,
        <div
          className={this.state.isMobile ? "bottom-barMobile" : "bottom-bar"}
        >
          Copyright © 2019-2021 | PrestMan | All Rights Reserved
        </div>,
        <DocumentTitle key="PrestMan" title="PrestMan" />,
      ];
    };

    return (
      <div className={this.state.isMobile ? "bodyMob" : "layout"}>
        <Header {...this.props}/>
        {renderInfo()}
      </div>
    );
  }
}
export default Home;
